import { format, parseJSON } from 'date-fns';
import React, { ElementType } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { InputBaseComponentProps, Theme, Tooltip } from '@mui/material';
import {
    GridEditInputCell,
    GridEditSingleSelectCell,
    // GridPreProcessEditCellProps,
    GridRenderEditCellParams,
    GridValidRowModel,
    GridValueFormatter,
    // GridValueSetter,
} from '@mui/x-data-grid';

import { USD } from '@barboxx/utils';

// Maybe split to beer vs product

export const priceFormatter = <R extends GridValidRowModel = GridValidRowModel>(
    value?: number | null
): ReturnType<
    GridValueFormatter<R, number | undefined | null, string | undefined>
> => {
    switch (value) {
        case 0:
            return '--';
        case undefined:
        case null:
            return undefined;
        default:
            return USD(value).format();
    }
};

// export function beerPriceSetter(field) {
//     return function (value, row) {
//         const priceValue = value > 0 ? value : null;
//         return {
//             ...row,
//             price: priceValue,
//         };
//     } as GridValueSetter<Beer.BusinessDetails, number>;
// }

// export function preProcessBeerPrice(
//     params: GridPreProcessEditCellProps<number | null, Beer.BusinessDetails>
// ) {
//     let errorMessage = '';
//     const hasError =
//         params.props?.value === undefined
//             ? true
//             : !(params.props.value === null || params.props.value > 0);

//     if (hasError) {
//         errorMessage = 'must set price to be active';
//     }

//     return { ...params.props, error: hasError, errorMessage };
// }
// export function preProcessUpcharge(
//     params: GridPreProcessEditCellProps<number>
// ) {
//     let errorMessage = '';
//     const hasError =
//         params.props?.value === undefined
//             ? true
//             : !(params.props.value === null || params.props.value > 0);

//     if (hasError) {
//         errorMessage = 'must set price to be active';
//     }

//     return { ...params.props, error: hasError, errorMessage };
// }

// interface PriceCheckOptions {
//     acceptNull?: boolean;
//     acceptZero?: boolean;
// }

// const checkForValidPrice = (
//     price?: number | null,
//     options?: PriceCheckOptions
// ) => {
//     const { acceptNull = false, acceptZero = false } = options || {};

//     switch (price) {
//         case undefined:
//             return false;
//         case null:
//             return acceptNull;
//         case 0:
//             return acceptZero;
//         default:
//             return price > 0;
//     }
// };

// export const preProcessPourSizeBrandsPrice =
//     (type: LiquorPourTypes) =>
//     (
//         params: GridPreProcessEditCellProps<
//             number | null,
//             AlcoholBrand.BusinessBrandDetails
//         >
//     ) => {
//         const isSingle = type === 'single';
//         const { value } = params.props;
//         const priceTier =
//             params?.otherFieldsProps?.['priceTier']?.value ??
//             ('Well' as AlcoholBrandPriceTiers);
//         let errorMessage = '';
//         let hasError = !checkForValidPrice(value, {
//             acceptZero: priceTier === 'Well',
//         });

//         if (value === 0 && priceTier !== 'Well') {
//             errorMessage = "Price can't be 0";
//         }

//         const otherValue = isSingle
//             ? params?.otherFieldsProps?.['priceDouble']?.value
//             : params?.otherFieldsProps?.['priceSingle']?.value;

//         if (typeof value === 'number') {
//             if (
//                 isSingle
//                     ? otherValue !== null && otherValue && otherValue <= value
//                     : otherValue && otherValue >= value
//             ) {
//                 errorMessage = `Value must be ${isSingle ? 'less' : 'greater'} than ${isSingle ? 'double' : 'single'}`;
//                 hasError = true;
//             }
//         }

//         return { ...params.props, error: hasError, errorMessage };
//     };

// export const preProcessPourSizePrice =
//     (type: LiquorPourTypes, emptyDoubleAllowed = true) =>
//     (
//         params: GridPreProcessEditCellProps<
//             number | null,
//             Cocktail.BusinessDetails
//         >
//     ) => {
//         const isSingle = type === 'single';
//         let errorMessage = '';
//         let hasError = !checkForValidPrice(params.props.value, {
//             acceptNull: emptyDoubleAllowed && type === 'double',
//         });

//         if (params.props.value === 0) {
//             errorMessage = "Price can't be 0";
//         }

//         if (typeof params.props.value === 'number') {
//             const otherValue = isSingle
//                 ? params?.otherFieldsProps?.['priceDouble']?.value
//                 : params?.otherFieldsProps?.['priceSingle']?.value;

//             if (
//                 isSingle
//                     ? otherValue !== null &&
//                       otherValue &&
//                       otherValue <= params.props.value
//                     : otherValue && otherValue >= params.props.value
//             ) {
//                 errorMessage = `Value must be ${isSingle ? 'less' : 'greater'} than ${isSingle ? 'double' : 'single'}`;
//                 hasError = true;
//             }
//         }

//         return { ...params.props, error: hasError, errorMessage };
//     };

// export const preProcessBrandPriceTier = (
//     params: GridPreProcessEditCellProps<
//         AlcoholBrandPriceTiers | null,
//         AlcoholBrand.BusinessBrandDetails
//     >
// ) => {
//     let errorMessage = '';
//     let hasError = false;

//     if (params.props.value === null) {
//         return params.props;
//     }

//     const singleValue = params?.otherFieldsProps?.['priceSingle']?.value as
//         | number
//         | null;
//     const doubleValue = params?.otherFieldsProps?.['priceDouble']?.value as
//         | number
//         | null;

//     if (params.props.value === 'Well') {
//         if (singleValue !== 0 || doubleValue !== 0) {
//             errorMessage = `Value must be 0`;
//             hasError = true;
//         }
//     } else {
//         if (
//             !singleValue ||
//             singleValue <= 0 ||
//             !doubleValue ||
//             doubleValue <= 0
//         ) {
//             errorMessage = `Value must be greater than 0`;
//             hasError = true;
//         }
//     }

//     return { ...params.props, error: hasError, errorMessage };
// };

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

export const NumericFormatCustom = React.forwardRef<
    NumericFormatProps,
    CustomProps
>(function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            thousandSeparator
            valueIsNumericString
            prefix="$"
            max={100}
            min={0}
            inputMode="decimal"
        />
    );
}) as unknown as ElementType<InputBaseComponentProps>;

export function renderPriceEditCell({
    errorMessage,
    error,
    ...params
}: GridRenderEditCellParams) {
    return (
        <Tooltip
            title={errorMessage}
            hidden={!errorMessage}
            open={error}
            color="error"
            arrow
        >
            <GridEditInputCell
                {...params}
                error={error}
                type="text"
                inputComponent={NumericFormatCustom}
            />
        </Tooltip>
    );
}

export const errorCellStyling = (theme: Theme) => ({
    '& .Mui-error': {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.main,
    },
});

export function renderEditSingleSelectCellWithError({
    errorMessage,
    ...params
}: GridRenderEditCellParams) {
    return <GridEditSingleSelectCell {...params} />;
}

export const dateFormatter = (value: string) =>
    value ? format(parseJSON(value), 'MM/dd/yyyy hh:mm:ss a') : null;

export const currencyFormatter = (value: number) => USD(value).format();
